module.exports = __webpack_public_path__ + "static/media/4-3.3d12bd71.mp3";